<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Personal Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Title -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="title">Title</label>
            <p id="title"><span v-if="worker.person.title_id !== null">{{ worker.person.title.value }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- First Name -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="first_name">First Name(s)</label>
            <p id="first_name"><span v-if="worker.person.first_name !== null">{{ worker.person.first_name }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Surname -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="surname">Surname</label>
            <p id="surname"><span v-if="worker.person.surname !== null">{{ worker.person.surname }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- D.O.B -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="dob">Date of Birth</label>
            <p id="dob"><span v-if="worker.person.dob !== null">{{ worker.person.dob | formatDate }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Display age -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="display_age">Age</label>
            <p id="display_age"><span v-if="worker.person.dob !== null">{{ calc_display_age(worker.person.dob) }}</span><span v-else>&nbsp;</span></p>
          </div>
          <div class="col-lg-4 form-group"></div>
          <!-- NI Number -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="ni_number">NI Number</label>
            <p id="ni_number"><span v-if="worker.rel_profile.ni_number !== null">{{ worker.rel_profile.ni_number }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Nationality -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="nationality">Nationality</label>
            <p id="nationality"><span v-if="worker.person.nationality_id !== null">{{ worker.person.nationality.nationality }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Is UK Citizen -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="nationality">UK Citizen</label>
            <p id="is_uk_citizen"><span v-if="worker.person.is_uk_citizen">Yes</span><span v-else>No</span></p>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-lg-6">
      <b-card header="Primary / Website Login Email" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Login Email Address -->
          <div class="col-xl-6 form-group">
            <label class="form-label" for="website_login_email">Login Email Address</label>
            <p id="website_login_email"><span v-if="emails.website_login !== null">{{ emails.website_login.email_address }}</span><span v-else>&nbsp;</span></p>
          </div>
          <div class="col-xl-6 form-group">
            <p class="mb-2 pt-0" style="font-size: 0.65rem;">This <strong>email is unique to the worker</strong>, it is the email address used to link the workers website
              profile to their ORCA record.</p>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-lg-6">
      <b-card header="Current Employment Status" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Current Status -->
          <div class="col-xl-6 form-group">
            <label class="form-label" for="employment_status">Current Status</label>
            <p id="employment_status">
              <span v-if="worker.rel_company_info.employment_type !== null">{{ worker.rel_company_info.employment_type.value }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Job Title -->
          <div class="col-xl-6 form-group">
            <label class="form-label" for="job_title">Job Title</label>
            <p id="job_title">
              <span v-if="worker.rel_profile.job_title_id !== null && (worker.rel_profile.job_title.sector !== null && Object.keys(worker.rel_profile.job_title.sector).length > 1)">
                {{ worker.rel_profile.job_title.job_title }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Job Town -->
          <div class="offset-xl-6 col-xl-6 form-group">
            <label class="form-label" for="job_town">Job Town</label>
            <p id="job_town">
              <span v-if="worker.rel_profile.job_town !== null">
                {{ worker.rel_profile.job_town }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-lg-8">
      <b-card header="Personal Contact Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Mobile Number -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="mobile">Mobile Number</label>
            <p id="mobile"><span v-if="phones.personal_mobile !== null">{{ phones.personal_mobile.phone_number }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Landline Phone Number -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="telephone">Landline Phone Number</label>
            <p id="telephone"><span v-if="phones.personal_landline !== null">{{ phones.personal_landline.phone_number }}</span><span v-else>&nbsp;</span></p>
          </div>
          <div class="col-lg-4 form-group">
            <label class="form-label" for="personal_email">Personal Email Address</label>
            <p id="personal_email"><span v-if="emails.personal !== null">{{ emails.personal.email_address }}</span><span v-else>&nbsp;</span></p>
          </div>
        </div>
        <div class="row" v-if="addresses.home !== null">
          <div class="col-12">
            <hr class="mt-0">
          </div>
          <!-- Personal Address -->
          <div class="col-12">
            <h5 class="font-weight-bold">Personal Address</h5>
          </div>
          <!-- Full Address -->
          <div class="col-12 form-group">
            <label class="form-label" for="h_address_full">Full Address</label>
            <p id="h_address_full"><span v-if="addresses.home.full">{{ addresses.home.full }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Home Building -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="h_address_building">Building</label>
            <p id="h_address_building"><span v-if="addresses.home.building">{{ addresses.home.building }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Home Street -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="h_address_street">Street</label>
            <p id="h_address_street"><span v-if="addresses.home.street">{{ addresses.home.street }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Home Locality -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="h_address_locality">Locality</label>
            <p id="h_address_locality"><span v-if="addresses.home.locality">{{ addresses.home.locality }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Home City/Town -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="h_address_city_town">City / Town</label>
            <p id="h_address_city_town"><span v-if="addresses.home.city_town">{{ addresses.home.city_town }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Home County -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="h_address_county">County</label>
            <p id="h_address_county"><span v-if="addresses.home.county">{{ addresses.home.county }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Home Postcode -->
          <div class="col-xl-4 form-group">
            <label class="form-label" for="h_address_postcode">Postcode</label>
            <p id="h_address_postcode"><span v-if="addresses.home.postcode">{{ addresses.home.postcode }}</span><span v-else>&nbsp;</span></p>
          </div>
          <div class="col-12">
            <hr class="mt-0">
          </div>
        </div>
        <div class="row">
        <!-- Next of Kin -->
        <div class="col-12">
          <h5 class="font-weight-bold">Next of Kin Information</h5>
        </div>
        <!-- NOK Full Name -->
        <div class="col-xl-6 form-group">
          <label class="form-label" for="nok_name">Contact Name</label>
          <p id="nok_name"><span v-if="worker.rel_profile.nok_name !== null">{{ worker.rel_profile.nok_name }}</span><span v-else>&nbsp;</span></p>
        </div>
        <!-- NOK Contact Number -->
        <div class="col-xl-6 form-group">
          <label class="form-label" for="nok_number">Contact Number</label>
          <p id="nok_number"><span v-if="worker.rel_profile.nok_contact_number !== null">{{ worker.rel_profile.nok_contact_number }}</span><span v-else>&nbsp;</span></p>
        </div>
        </div>
      </b-card>
    </div>
    <div class="col-lg-4">
      <b-card header="Personal Bank Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Bank Name -->
          <div class="col-lg-12 col-md-4 form-group">
            <label class="form-label" for="bank_name">Bank Name</label>
            <p id="bank_name"><span v-if="banks.personal !== null">{{ banks.personal.bank_name }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Branch Location -->
          <div class="col-lg-12 col-md-4 form-group">
            <label class="form-label" for="branch_location">Branch Location</label>
            <p id="branch_location"><span v-if="banks.personal !== null">{{ banks.personal.branch_location }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Account Holder Name('s) -->
          <div class="col-lg-12 col-md-4 form-group">
            <label class="form-label" for="accounts_holder">Account Holder Name('s)</label>
            <p id="accounts_holder"><span v-if="banks.personal !== null">{{ banks.personal.accounts_holder }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Account Number -->
          <div class="col-lg-12 col-md-4 form-group">
            <label class="form-label" for="account_number">Account Number</label>
            <p id="account_number"><span v-if="banks.personal !== null">{{ banks.personal.account_number }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Sort Code -->
          <div class="col-lg-12 col-md-4 form-group">
            <label class="form-label" for="sort_code">Sort Code</label>
            <p id="sort_code"><span v-if="banks.personal !== null">{{ banks.personal.sort_code }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Building Society Ref Number -->
          <div class="col-lg-12 col-md-4 form-group">
            <label class="form-label" for="bsoc_ref">Building Society Ref Number</label>
            <p id="bsoc_ref"><span v-if="banks.personal !== null">{{ banks.personal.building_society_ref }}</span><span v-else>&nbsp;</span></p>
          </div>
          <!-- Last confirmed details -->
          <div class="col-lg-12 col-md-4 form-group">
            <label class="form-label" for="account_confirmed_user">Last confirmed details:</label>
            <p id="account_confirmed_user"><span v-if="banks.personal !== null && banks.personal.account_confirmed_user_name">{{ banks.personal.account_confirmed_user_name }} @ {{ banks.personal.account_confirmed_user_date }}</span><span v-else>&nbsp;</span></p>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "personal_info",
  props: ['worker', 'emails', 'phones', 'addresses', 'banks'],
  data() {
    return {
      // Set Genius PA Insurance value from env file
      // pa_ins: process.env.MIX_PA_INS,
    }
  },
  methods: {
    calc_display_age(dob) {
      return this.$moment().diff(dob, 'years',false) + ' years old'
    }
  }
}
</script>
